//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class PracticeLogSearchOptions extends ItemBase {
    PracticeLogIDs: string[] = [];
    StudentIDs: string[] = [];
    MinDate: string | null = null;
    MaxDate: string | null = null;
    SearchText: string | null = null;
    TeacherIDs: string[] = [];

    constructor(initializer?: Partial<PracticeLogSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PracticeLogSearchOptions";
}
